export var getTotalPay = function (shiftDuration, payRates, payModifiers) {
    var _a;
    var effectiveRate = !!(payRates === null || payRates === void 0 ? void 0 : payRates.shiftDifferential)
        ? payRates.rate + payRates.shiftDifferential
        : payRates === null || payRates === void 0 ? void 0 : payRates.rate;
    var netBaseAmount = effectiveRate ? shiftDuration * effectiveRate : 0;
    var incentivePayTotal = 0;
    if (!!payModifiers) {
        for (var _i = 0, payModifiers_1 = payModifiers; _i < payModifiers_1.length; _i++) {
            var payModifier = payModifiers_1[_i];
            incentivePayTotal += ((_a = payModifier.applicableNetAmount) === null || _a === void 0 ? void 0 : _a.amount) || 0;
        }
    }
    return netBaseAmount + incentivePayTotal;
};
